<template>
<div>
    <div class="page-pop" v-if="showGlobalToast" @click="close()"></div>
    <div class="page-pop-content" v-if="showGlobalToast">                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
        <div class="close" @click="close()"><img src="@/assets/newImages/home/cover-close.png" alt=""></div>
        <div class="text">{{showGlobalToastMsg}}</div>
    </div>
</div>
</template>

<script>
export default {
    props:{
    },
    computed:{
        showGlobalToast(){
            return this.$store.state.showGlobalToast;
        },
        showGlobalToastMsg(){
            return this.$store.state.showGlobalToastMsg;
        },
    },
    methods: {
        close(){
            this.$store.commit('setShowGlobalToast', false);
        }
    }
}
</script>

<style scoped lang="scss">
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.page-pop{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100000;
    cursor: pointer;
    width: 100vw;height: 100vh;
    background: rgba($color: #000000, $alpha: 0.65);
}
.page-pop-content{
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 100001;
    width: pxToVw(550);
    height: pxToVw(285);
    padding-top: pxToVw(76);
    background: #FFFFFF;
    border-radius: pxToVw(9);
    transform: translate(-50%,-50%);
    .close{
        position: absolute;
        right: 0;top: 0;
        width: pxToVw(67);
        height: pxToVw(67);
        padding: pxToVw(24);
        cursor: pointer;
        img{
            vertical-align: top;
            width: pxToVw(19);
            height: pxToVw(19);
        }
    }
    .text{
        width: 100%;
        height: 100%;
        // height: pxToVw(72);
        padding: 0 pxToVw(30) pxToVw(60);
        font-size: pxToVw(19);
        justify-content: center;
        display:flex;
        align-items: center;
        text-align: center;
        color: #666666;
        line-height: pxToVw(32);
    }
    .button{
        width: pxToVw(200);
        margin: 0 auto;
        height: pxToVw(53);
        background: #C50819;
        border-radius: pxToVw(6);
        font-size: pxToVw(19);
        text-align: center;
        color: #FFF;
        cursor: pointer;
        line-height: pxToVw(53);
    }
}
@media screen and (max-width:767px) {
    .page-pop-content{
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1001;
    width: 80vw;
    height: 50vw;
    padding-top: 10vw;
    background: #FFFFFF;
    border-radius: pxToVw(9);
    transform: translate(-50%,-50%);
    .close{
        position: absolute;
        right: 0;top: 0;
        width: 10vw;
        height: 10vw;
        padding: 3.5vw;
        cursor: pointer;
        img{
            vertical-align: top;
            width: 3vw;
            height: 3vw;
        }
    }
    .text{
        width: 100%;
        height: 100%;
        padding: 0 3vw 10vw;
        font-size: 3.6vw;
        justify-content: center;
        display:flex;
        align-items: center;
        text-align: center;
        color: #666666;
        line-height: 5vw;
    }
}
}
</style>